import styled from 'styled-components';
import { theme } from '@tools/ui-utils/theme.util';

type TProps = { width?: number; top: number; left: number };

export default styled.div<TProps>`
  cursor: pointer;
  .ant-popover-arrow {
    display: none;
  }
  .ant-popover {
    position: fixed;
    top: ${({ top }) => top}px !important;
    left: ${({ left }) => left}px !important;
    .ant-popover-inner {
      width: ${({ width = 280 }) => width}px;
    }
    .ant-popover-title {
      border-bottom: none;
      padding-top: ${theme.spacing(2)}px;
    }
    .ant-popover-inner-content {
      padding-top: ${theme.spacing(0.5)}px;
      padding-left: 0px;
      padding-right: 0px;
    }
  }
`;
